<template>
    <div
        ref="root"
        class="header-stamp"
        v-if="
            certificatePreviewItems &&
                Array.isArray(certificatePreviewItems) &&
                certificatePreviewItems.length > 0
        "
        v-bind:data-valid-until="certificatePreviewItems[0].data.expires"
    >
        <div class="header-stamp__outer">
            <component
                :is="
                    certificatePreviewItems[0].data.linkActive &&
                    certificatePreviewItems[0].data.link
                        ? 'a'
                        : 'div'
                "
                v-bind:href="certificatePreviewItems[0].data.link"
                v-bind:target="'_blank'"
                v-bind:class="'header-stamp__inner'"
            >
                <app-moduleimage
                    :v-if="certificatePreviewItems[0].data && certificatePreviewItems[0].data.image"
                    :data="certificatePreviewItems[0].data.image"
                    :tag="'img'"
                    :width="75"
                    :custom-class="'header-stamp__image'"
                ></app-moduleimage>
                <div
                    class="header-stamp__title"
                    v-if="certificatePreviewItems[0].data && certificatePreviewItems[0].data.name"
                    v-html="certificatePreviewItems[0].data.name"
                ></div>
            </component>
        </div>
    </div>
</template>

<script>
import { toArray } from '@/helpers/utils';
import { mapGetters, mapActions } from 'vuex';
import ModuleImage from '@/components/assorted/ModuleImage';
import Certifications from '@/external/assorted/Certifications';

export default {
    data() {
        return {};
    },
    components: {
        'app-moduleimage': ModuleImage
    },
    methods: {
        ...mapActions(['scrollInsideEditor', 'editorMode'])
    },
    computed: {
        ...mapGetters(['generateMediaUrl', 'getListItems', 'getRandomImageInNamespace']),
        certificatePreviewItems() {
            return toArray(this.getListItems('deha.user.misc.certifications'))
                .filter((i) => (i.data && i.data.headerPreview ? i.data.headerPreview : false))
                .sort((a, b) => a.pos - b.pos);
        }
    },
    updated() {
        Certifications.init();
    },
    created() {},
    mounted() {},
    props: {}
};
</script>
